import { createFileRoute, redirect, Outlet } from '@tanstack/react-router';
import { useAuthStore } from '@/stores/authStore';
import { requireStudent } from '@/lib/guards';

export const Route = createFileRoute('/_student')({
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState();
    if (!isAuthenticated) {
      throw redirect({ to: '/login' });
    }
    requireStudent(); // non-students → their role home
  },
  component: () => <Outlet />,
});
